import isRequired from '@/mixins/component/is-required-mixin';
import { getRequiredLabelProp } from '@/components/global_components/forms/utils/required-label-util';

export default {
  mixins: [isRequired],
  computed: {
    computedLabel() {
      return getRequiredLabelProp(this.$props).label;
    }
  }
}
